import { inject, Injectable, DOCUMENT } from '@angular/core';
import { SwiperOptions } from 'swiper/types';
import { isServer } from '../utilities/platform-type';
import { moduleMap, SwiperModuleId } from './utils';

@Injectable({
  providedIn: 'platform'
})
export class SwiperStyleInjectorService {
  private readonly document = isServer() ? null : inject(DOCUMENT);

  private readonly injected = new Set<string>();

  private readonly mainStyle = (() => {
    if (!this.document)
      return null;
    const mainStyleRegex = /styles(-.*)?\.css/;
    const styleLinks = [] as HTMLLinkElement[];

    this.document.head.querySelectorAll('link').forEach(l => styleLinks.push(l));
    const mainStyleLink = styleLinks.find(l => mainStyleRegex.test(l.href));


    if (!mainStyleLink)
      throw new Error('invalid operation');

    return mainStyleLink;
  })();

  private readonly swiperStlye = (() => {
    if (!this.document || !this.mainStyle)
      return null;

    const style = this.document.createElement('style');
    this.mainStyle.insertAdjacentElement('beforebegin', style);

    return style;
  })();

  public async injectModules(opts: SwiperOptions, modules: readonly SwiperModuleId[]) {
    if (!this.swiperStlye)
      return;

    this.injected.add('/assets/swiper/swiper.min.css');

    modules.map(m => `/assets/swiper/modules/${m}.min.css`)
      .forEach(url => this.injected.add(url));

    this.swiperStlye.textContent = [...this.injected]
      .map(url => importCssUrl(url, 'base'))
      .join('\n');

    opts.modules = await Promise.all(modules.map(m => moduleMap[m]()));
  }
}

function importCssUrl(link: string, layer?: string) {
  let line = `@import url('${link}')`;
  if (layer) {
    line += ` layer(base)`;
  }

  line += ';';


  return line;
}